import React, { useState, useEffect } from "react";
import css from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const routes = {
  home: "/",
  brief: "/about/brief",
  history: "/about/history",
  partner: "/about/partner",
  prod: "/prodandsolution/prod",
  solution: "/prodandsolution/solution",
  ito: "/service/ito",
  bpo: "/service/bpo",
  news: "/news/center",
  notice: "/notice",
  joinus: "/join/joinus",
  board: "/join/board",
};

function Bot() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(window.innerWidth < 1025);

  const goTo = (str) => {
    navigate(routes[str]);
  };

  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth < 1025);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const goFirst = () => {
    window.open(
      "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602000557",
      "_blank"
    );
  };
  const goSecond = () => {
    window.open("https://beian.miit.gov.cn/", "_blank");
  };

  return (
    <>
      {mobile ? (
        <div className={css.containerMobile}>
          <div className={css.top}>
            <div className={css.right}>
              <div className={css.qrcodebox}>
                <div className={css.qrcode}></div>
                <div className={css.qrcodetext}>{t("$singlee_bt1")}</div>
              </div>
              <div className={css.contentzone}>
                <div className={css.contact}>{t("$singlee_ju12")}</div>
                <div className={css.phone}>{t("0571-88480666")}</div>
                <div className={css.address}>
                  <div className={css.location}></div>
                  <div style={{ flex: "1" }}>{t("$singlee_ju15")}</div>
                </div>
                <div className={css.cz}>
                  <div className={css.print}></div>
                  {t("0571-89712755")}
                </div>
              </div>
            </div>
          </div>
          <div className={css.bot}>
            <div className={css.left}>
              {"CopyRight © 2006-2023 " +
                t("$singlee_ju13") +
                " " +
                t("$singlee_bt2")}
            </div>
            <div className={css.right}>
              <span onClick={goFirst}>{t("浙公网安备 33010602000557号")}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span onClick={goSecond}>{t("浙ICP备05007619号")}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className={css.container}>
          <div className={css.top}>
            <div className={css.left}>
              <div className={css.item}>
                <div className={css.title} onClick={() => goTo("home")}>
                  {t("首页")}
                </div>
              </div>
              <div className={css.item}>
                <div className={css.title}>{t("产品")}</div>
                <div className={css.sub} onClick={() => goTo("prod")}>
                  {t("产品")}
                </div>
                <div className={css.sub} onClick={() => goTo("solution")}>
                  {t("解决方案")}
                </div>
              </div>
              <div className={css.item}>
                <div className={css.title}>{t("服务")}</div>
                <div className={css.sub} onClick={() => goTo("ito")}>
                  {t("信息技术服务外包")}
                </div>
                <div className={css.sub} onClick={() => goTo("bpo")}>
                  {t("业务流程外包")}
                </div>
              </div>
              <div className={css.item}>
                <div className={css.title} onClick={() => goTo("news")}>
                  {t("新闻中心")}
                </div>
              </div>
              <div className={css.item}>
                <div className={css.title} onClick={() => goTo("notice")}>
                  {t("公司公告")}
                </div>
              </div>
              <div className={css.item}>
                <div className={css.title}>{t("关于新利")}</div>
                <div className={css.sub} onClick={() => goTo("brief")}>
                  {t("关于我们")}
                </div>
                <div className={css.sub} onClick={() => goTo("joinus")}>
                  {t("加入我们")}
                </div>
                <div className={css.sub} onClick={() => goTo("board")}>
                  {t("留言板")}
                </div>
              </div>
              {/* <div className={css.item}>
                <div className={css.title} onClick={() => goTo("joinus")}>
                  {t("加入新利")}
                </div>
                
              </div> */}
            </div>
            <div className={css.right}>
              <div className={css.contentzone}>
                <div className={css.contact}>{t("$singlee_ju12")}</div>
                <div className={css.phone}>{t("0571-88480666")}</div>
                <div className={css.address}>
                  <div className={css.location}></div>
                  {t("$singlee_ju15")}
                </div>
                <div className={css.cz}>
                  <div className={css.print}></div>
                  {t("0571-89712755")}
                </div>
              </div>
              <div className={css.qrcodebox}>
                <div className={css.qrcode}></div>
                <div className={css.qrcodetext}>{t("$singlee_bt1")}</div>
              </div>
            </div>
          </div>
          <div className={css.bot}>
            <div className={css.left}>
              {"CopyRight © 2006-2023 " +
                t("$singlee_ju13") +
                " " +
                t("$singlee_bt2")}
            </div>
            <div className={css.right}>
              <span style={{ cursor: "pointer" }} onClick={goFirst}>
                {t("浙公网安备 33010602000557号")}
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <span style={{ cursor: "pointer" }} onClick={goSecond}>
                {t("浙ICP备05007619号")}
              </span>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(Bot);
